import {useState,useEffect} from 'react';
import realtimeDB from "../../Utils/api";
import moment from "moment";

const usePopupsAdmin=()=>
{
    const [Popups, setPopups] = useState([]);
    useEffect(() => 
    {
        const HoraActual=new Date().getHours();
        const MinutoActual=new Date().getMinutes();


        realtimeDB.ref("/pop-ups").on("value",snapshot =>
        {   
          
            let popups=[];
            snapshot.forEach(popup =>
            {
                const Popup = {id:popup.key, data:popup.val()}
                popups.push(Popup);
            });
            setPopups(popups);
        })
    }, [])
    return Popups;
}

export default usePopupsAdmin;
